export enum PaymentMethodEnum {
  PAYPAL = 'PAYPAL',
  MOBILE_MONEY = 'MOBILE_MONEY',
  BANK_TRANSFERT = 'BANK_TRANSFERT'
}

export enum PaymentMethodRequestStatusEnum {
  IMPLEMENTED = 'IMPLEMENTED',
  NEW = 'NEW',
  SEEN = 'SEEN'
}
